class ProductSelector extends HTMLElement {
  constructor() {
    super();
    this.inputWrapper = '[data-input-wrapper]';
    this.variants = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.form = document.querySelector(
      `#ProductForm-${this.dataset.sectionId}`
    );
    this.purchaseOptions = document.querySelector(
      `#Product-Purchase-Options-${this.dataset.sectionId}`
    );
    this.productBar = document.querySelector(
      `#ProductBar-${this.dataset.sectionId}`
    );
    this.installmentsForm = document.querySelector(
      `#Product-Installments-${this.dataset.installmentsFormId}` // check: `${this.dataset.installmentsFormId}`
    );
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
    this.updateVariantStatuses();
    this.updateVariant();

    this.form.toggleAddButton(!this.currentVariant.available, '');
  }
  connectedCallback() {
    this.updateSwatchButtonState();
    this.updateGridStyles();
    this.updateMedia();
    this.updateSku()
  }

  updateGridStyles() {
    const matchingItems = Array.from(document.querySelectorAll(".media_grid_item"));

    if (matchingItems.length === 0) return;

    matchingItems.forEach((item, index) => {
      item.style.gridColumn =
        matchingItems.length % 2 !== 0 && (index + 1) % 3 === 0
          ? "span 1"
          : "span 1";
    });
  }

  updateSwatchButtonState() {
    this.querySelectorAll(".inner_options").forEach((i) => {
      const inputField = i.querySelector("input");
        
      if (inputField && !inputField.disabled) {
        i.addEventListener("click", (i) => {
        let inpVal = i.currentTarget.querySelector("input").value
         console.log(inpVal , "input value")
 const swatchButtonOuter = document.querySelector(
      ".size_btn_container .product__swatch--button-outer"
    );

if (swatchButtonOuter) {
  console.log("swatchButtonOuter found:", swatchButtonOuter);
  const sizeTextSpan = swatchButtonOuter.querySelector(".size_text_s");

  if (sizeTextSpan) {
    console.log("sizeTextSpan found:", sizeTextSpan);
    sizeTextSpan.innerText = inpVal;
    console.log(sizeTextSpan.innerText, "in", inpVal);
  } else {
    console.log("sizeTextSpan not found");
  }
} else {
  console.log("swatchButtonOuter not found");
}



          const closeButton =
            this.getElementsByClassName("swatch_popup_close")[0];
          if (closeButton) {
            closeButton.click();
          } else {
            console.error(
              "No element with class swatch_popup_close found inside the current element"
            );
          }
        });
      }
    });

 



   
  }
  updateVariantStatuses() {
    const optionOneValue = this.querySelector(
      this.inputWrapper
    ).querySelector(':checked').value;
    const selectedOptionOneVariants = this.variants.filter(
      variant => optionOneValue === variant.option1
    );
    const inputWrappers = [
      ...this.querySelectorAll(this.inputWrapper)
    ];

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value;
      const listOfAvailableOptions = selectedOptionOneVariants
        .filter(
          variant =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map(variantOption => variantOption[`option${index + 1}`]);

      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option')
      ];

      optionInputs.forEach(input => {
        const inputIsDisabled = !listOfAvailableOptions.includes(
          input.getAttribute('value')
        );



        input.disabled = inputIsDisabled;
        if (input.tagName.toLowerCase() === 'option') {
          input
            .closest('dropdown-input')
            .querySelector(
              `button[data-value="${input.value}"]`
            ).disabled = inputIsDisabled;
        }
        if (!this.productBar) return;
        const inputId = input.dataset.id || input.id;
        const productBarInput = this.productBar.querySelector(
          `option[data-id="${inputId}"]`
        );
        if (!productBarInput) return;
        productBarInput.disabled = inputIsDisabled;
      });
    });
  }

  onVariantChange(event) {
    if (event.target.type === 'number') return;
    this.updateOptions();
    if (this.currentVariant === this.getVariantData()) return;

    this.updateVariant();
    this.updateVariantStatuses();
    this.productBarUpdateOptions();
    this.updatePickupAvailability();
    this.form.removeAttribute('data-has-selling-plan');
    this.form.toggleAddButton(false, '');
    this.form.handleErrorMessage();

    if (!this.currentVariant) {
      this.form.toggleAddButton(true, '');
      this.setUnavailable();

      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.form.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateMetafield()
    this.updateButton()
    this.updateSku()
  }

updateSku() {
  if (!this.currentVariant) return;

  const variantSkus = document.querySelectorAll(".v_sku");
  variantSkus.forEach((sku) => {
    if (sku.dataset.variantId == this.currentVariant.id) {
      sku.classList.add('selected_sku');
    } else {
      sku.classList.remove('selected_sku');
    }
  });
}


updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const productMedia = document.querySelector("product-media");
    const mediaGrid = productMedia.querySelector(".product_media_grid");

    if (!mediaGrid) {
      productMedia.setActiveMedia(this.currentVariant.featured_media.id);
    }

    // Update media grid based on alt text
    const mediaAltText = this.currentVariant.featured_media.alt || "";
    this.filterAndDisplayImages(productMedia, mediaAltText);

    // Enable Swiper for smaller screens
    this.enableSwiper(productMedia);
  }

  filterAndDisplayImages(productMedia, mediaAltText) {
    if (!this.allMediaItems) {
      this.allMediaItems = Array.from(
        productMedia.querySelectorAll(".media_grid_item")
      );
    }
  
    const matchingItems = this.allMediaItems.filter((mediaItem) => {
      const image = mediaItem.querySelector("img");
      return image && image.alt === mediaAltText;
    });

    if (matchingItems.length % 2 !== 0) {
      matchingItems.forEach((item, index) => {
        if ((index + 1) % 3 === 0) {
          item.style.gridColumn = "span 1";
        } else {
          item.style.gridColumn = "span 1";
        }
      });
    } else {
      matchingItems.forEach((item) => {
        item.style.gridColumn = "span 1";
      });
    }

    const mediaGrid = productMedia.querySelector(".product_media_grid");
    if (mediaGrid) {
      mediaGrid.innerHTML = "";
      matchingItems.forEach((item) => mediaGrid.appendChild(item));
    }
    this.enableSwiper(productMedia);
  }

  enableSwiper(productMedia) {
    const mediaContainer = productMedia.querySelector(
      ".product_media_container"
    );
    const screenWidth = window.innerWidth;

    if (!mediaContainer) {
      console.error("Media container not found!");
      return;
    }

    if (mediaContainer.dataset.swiperInstance) {
      const existingSwiper = mediaContainer.dataset.swiperInstance;
      if (existingSwiper.destroy) {
        existingSwiper.destroy(true, true);
      }
      delete mediaContainer.dataset.swiperInstance;
      mediaContainer.classList.remove("swiper-initialized");
    }

    // Reinitialize Swiper for screens below 760px
    if (screenWidth <= 760) {
      const swiperOptions = {
        slidesPerView: 1,
        direction: "horizontal",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      };

      const swiperWrapper = mediaContainer.querySelector(".product_media_grid");
      const slides = swiperWrapper?.querySelectorAll(".swiper-slide");

      if (!slides || slides.length === 0) {
        console.error("No slides found in media container!");
        return;
      }

      const swiper = new Swiper(mediaContainer, swiperOptions);
      console.log("Initialized Swiper:", swiper);
      mediaContainer.dataset.swiperInstance = swiper;
    }
  }

 updateMetafield() {
    const variantId = this.currentVariant.id;
    const metafieldDivs = document.querySelectorAll("[data-product-metafield]");

    if (metafieldDivs.length > 0) {
      metafieldDivs.forEach((div) => {
        const variantDivId = div.getAttribute("data-variant-id");
        if (variantDivId === String(variantId)) {
          div.classList.add("selected_variant");
        } else {
          div.classList.remove("selected_variant");
        }
      });
    } else {
      console.log("No divs with data-product-metafield found");
    }
  }

  updateButton() {

   
 
    if (!this.currentVariant) return;
 
    const activeButtonText = this.currentVariant.option2;
   console.log(activeButtonText)

    const swatchButtonOuter = this.querySelector(
      ".size_btn_container .product__swatch--button-outer"
    );

    if (swatchButtonOuter) {
    
      const sizeTextSpan = swatchButtonOuter.querySelector(".size_text");
   
      if ( sizeTextSpan) {
      

        
        sizeTextSpan.innerText = activeButtonText;

        const buttonOuterText = sizeTextSpan.innerText.trim();
        if (buttonOuterText === activeButtonText) {
          swatchButtonOuter.classList.add("is-active");
        } else {
          swatchButtonOuter.classList.remove("is-active");
        }
      }
    }
  }




  updateOptions() {
    this.querySelectorAll('input[type="radio"]').forEach(input => {
      input.nextElementSibling.classList.toggle(
        'is-active',
        input.checked
      );
    });
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      el => ({ name: el.dataset.name || el.name, value: el.value })
    );
  }

  productBarUpdateOptions() {
    if (this.productBar) {
      Array.from(this.productBar.querySelectorAll('select')).map(
        selector => {
          selector.value = this.options.find(
            option => option.name === selector.name
          ).value;
        }
      );
      // update dropdowns in product bar
      this.productBar.querySelectorAll('dropdown-input').forEach(
        dropdown => {
          // update dropdown list with usage update() of 'class DropdownInput extends HTMLElement' in global.js
          dropdown.update();
        }
      );
    }
  }

  updateInventoryNotice(html) {
    const destination = document.querySelector('[data-inventory-notice]');
    const source = html.querySelector('[data-inventory-notice]');

    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updatePickupAvailability() {
    const pickUpAvailabilityNode = document.querySelector(
      'pickup-availability'
    );

    if (!pickUpAvailabilityNode || !this.currentVariant) return;

    pickUpAvailabilityNode.dataset.variantId = this.currentVariant.id;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailabilityNode.setAttribute('available', '');
      pickUpAvailabilityNode.fetchAvailability(
        pickUpAvailabilityNode.dataset.variantId
      );

      return;
    }

    pickUpAvailabilityNode.removeAttribute('available');
    pickUpAvailabilityNode.innerHTML = '';
  }

  updateVariant() {
    this.currentVariant = this.getVariantData();
  }

  getVariantData() {
    return this.options.length
      ? this.variants.find(variant => {
          return !variant.options
            .map(
              (option, index) => this.options[index].value === option
            )
            .includes(false);
        })
      : this.variants[0];
  }

  

  updateURL(sellingPlanId) {
    if (!this.currentVariant) return;
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id
    );
    if (sellingPlanId) {
      params[params.has('selling_plan') ? 'set' : 'append'](
        'selling_plan',
        sellingPlanId
      );
    } else {
      params.delete('selling_plan');
    }
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?${params.toString()}`
    );
  }

  updateVariantInput() {
    const inputs = [
      this.querySelector('[name="id"'),
      this.installmentsForm?.querySelector('[name="id"]')
    ];
    inputs.forEach(input => {
      if (!input) return;
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  setUnavailable() {
    const submitButton = this.form.submitButton;
    const price = this.querySelector(
      `#Product-Price-${this.dataset.sectionId}`
    );

    if (!submitButton) return;
    submitButton.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id
    );
    params.append('section_id', this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );
        [
          `#Product-Price-${this.dataset.sectionId}`,
          `#Product-Purchase-Options-${this.dataset.sectionId}`
        ].map(liveRegionSelector => {
          const destination = document.querySelector(
            liveRegionSelector
          );
          const source = html.querySelector(liveRegionSelector);

          this.updateInventoryNotice(html);

          if (destination && source) {
            destination.classList.remove('visibility-hidden');
            destination.innerHTML = source.innerHTML;
          }
        });
      });
  }
}

customElements.define('product-selector', ProductSelector);
